module.exports = __webpack_public_path__ + "img/work-6.7c99009a.png";